import React, { useState, useEffect, useContext } from "react";
import { Button, useDisclosure, Tooltip } from "@chakra-ui/react";
import AddMyVoice from "../../Modals/AddMyVoice";
import { fetchController } from "../../../utils/FetchController/fetchController";
import WhatsAppModal from "../../Modals/WhatsApp";
import VoiceTimestampModal from "../../Modals/VoiceTimestampModal";
import { SettingContext } from "../Reducer/SettingProvider";
import { AgencyContext } from "../AgencyProvider/AgencyProvider";
import AuthContext from "../../Auth/AuthContext";
import { getHostDomain, toBoolean } from "../../../utils/utils";

const MyVoiceButton = () => {
  const baseUrl = getHostDomain();
  const [isMyVoiceRecorded, setIsMyVoiceRecorded] = useState(false);
  const [voiceData, setVoiceData] = useState([]);
  const { state: activatedPlan } = useContext(SettingContext);
  const {
    isOpen: isAddMyVoiceModalOpen,
    onOpen: onAddMyVoiceModalOpen,
    onClose: onAddMyVoiceModalClose,
  } = useDisclosure();
  const {
    isOpen: isOpenWhatsApp,
    onOpen: onOpenWhatsapp,
    onClose: onCloseWhatsapp,
  } = useDisclosure();
  const {
    isOpen: isVoiceTimeStampModalOpen,
    onOpen: onVoiceTimeStampModalOpen,
    onClose: onVoiceTimeStampModalClose,
  } = useDisclosure();

  const { authUser } = useContext(AuthContext);

  const [image, setImage] = useState(null);

  useEffect(() => {
    if (authUser?.picture) {
      setImage(authUser.picture);
    }
  }, [authUser.picture]);

  const loadOwnVoice = async () => {
    const endpoint = `/api/v1/voice/list`;
    const urlHit = baseUrl + endpoint;
    const getData = await fetchController(urlHit, "GET");

    const modifiedData = getData?.data?.items?.map((val, index) => {
      return {
        value: val.id,
        label: val.name,
      };
    });
    setVoiceData(getData?.data?.items);
    setIsMyVoiceRecorded(modifiedData?.length > 0 ? true : false);
  };

  useEffect(() => {
    if (
      activatedPlan.plan_lookup_key !== "insightoai_free" ||
      activatedPlan.plan_lookup_key !== "insightoai_gold"
    ) {
      loadOwnVoice();
    }
  }, []);
  const agency = useContext(AgencyContext);
  const { buttonColorScheme, myDetails } = agency;

  const isMyVoiceBtnEnable = toBoolean(activatedPlan?.credits?.custom_voice);

  const toolTipMsg =
    myDetails && myDetails?.agency_id
      ? `Please contact ${myDetails?.branding?.agency_name || ""} `
      : "Please upgrade to Platinum or above";

  return (
    <>
      <Tooltip
        label={!isMyVoiceBtnEnable ? toolTipMsg : ""}
        aria-label="A tooltip"
      >
        <Button
          colorScheme={buttonColorScheme}
          onClick={
            isMyVoiceRecorded
              ? onVoiceTimeStampModalOpen
              : onAddMyVoiceModalOpen
          }
          isDisabled={!isMyVoiceBtnEnable}
        >
          My voice
        </Button>
      </Tooltip>
      <WhatsAppModal
        isOpen={isOpenWhatsApp}
        onOpen={onOpenWhatsapp}
        onClose={onCloseWhatsapp}
        data={[]}
      />
      {isAddMyVoiceModalOpen && (
        <AddMyVoice
          isAddMyVoiceModalOpen={isAddMyVoiceModalOpen}
          onAddMyVoiceModalClose={onAddMyVoiceModalClose}
          isMyVoiceRecorded={isMyVoiceRecorded}
          loadOwnVoice={loadOwnVoice}
          isUpdatingVoice={isMyVoiceRecorded}
          buttonColorScheme={buttonColorScheme}
        />
      )}
      <VoiceTimestampModal
        isVoiceTimeStampModalOpen={isVoiceTimeStampModalOpen}
        onVoiceTimeStampModalOpen={onVoiceTimeStampModalOpen}
        onVoiceTimeStampModalClose={onVoiceTimeStampModalClose}
        onAddMyVoiceModalOpen={onAddMyVoiceModalOpen}
        voiceData={voiceData}
        buttonColorScheme={buttonColorScheme}
      />
    </>
  );
};

export default MyVoiceButton;
